import React from 'react';
import MasterLayout from '../masterLayout/MasterLayout';
import WorkOrderReferencesLayer from '../components/WorkOrderReferencesLayer';

const WorkOrderReferencesPage = () => (
  <MasterLayout pageTitle='Work Order Reference Tables'>
    <WorkOrderReferencesLayer />
  </MasterLayout>
);

export default WorkOrderReferencesPage;
